import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';


function PrivateRoute({ children, ...rest }) {
  const currentUser = useSelector(({ User }) => User.currentUser);


  return (
    <Route
      {...rest}
      render={({ location }) =>
        currentUser ? children :
          <Redirect to={{
            pathname: '/',
            state: { from: location }
          }} />
      }
    />
  )

}


export default PrivateRoute;